const initialState = {
    locations: []
};

const EmployeeReviewsReducer = (state = initialState, action) => {
    switch (action.type) {
        case "SET_EMPLOYEE_REVIEWS_LOCATIONS":
            return {
                ...state,
                locations: action.payload
            };
        case "RESET_STORE":
            state = initialState;
            return state;
        default:
            return state;
    }
}

export default EmployeeReviewsReducer;
